<template>
<div id="homes"> 

  <div >   
     <b-row class="justify-content-center"> 
       <b-col cols="11" md="11" v-if="!isMobile" > 
         <b-row class="justify-content-center">
           <b-col cols="11" md="7" v-if="!isMobile">

          </b-col> 
           <b-col cols="10" md="6"  lg="5" xl="5" > 
             <div data-aos="zoom-in-down" >
                <p :class="isMobile ? 'text-white mt-5 text-center' : 'text-white text-right'" style="font-size: 15px; margin-top:10px;" v-if="user">   
                  ¡HOLA! {{user.nombre}}  
                   <b>   
                    <span class="text-secondary"  v-if="user.canal == 3"><b style="color:#fff;">&nbsp;&nbsp; PROPIO</b></span>
                    <span class="text-secondary"  v-if="user.canal == 2"><b style="color:#fff;">&nbsp;&nbsp; TELEMARKETING</b></span>
                    <span class="text-secondary"  v-if="user.canal == 1"><b style="color:#fff;">&nbsp;&nbsp; RETAIL</b></span> 
                    <span class="text-secondary"  v-if="user.canal == 4"><b style="color:#fff;">&nbsp;&nbsp; ESPECIALISTA</b></span> 
                  </b>
                  <br>
                  <img  src="elementos/hom.png" :class="!isMobile ? 'rounded' :'rounded'" alt="Image"  :style="!isMobile ? 'width:3%; cursor:pointer;  margin-top:-2px;' : 'width:5%; cursor:pointer; margin-top:-2px;'" @click="cambiarNav(0)"> 
                  <u :class="isMobile ? 'ml-5 mt-5' : 'ml-5 mt-5'" :style="nav == 7 ? 'color:#fff; cursor: pointer; z-index:10;' : 'color:#fff; cursor: pointer; z-index:10;'" @click="cambiarNav(7)">Contacto</u> 
                  <u :class="isMobile ? 'ml-5 mt-5' : 'ml-5 mt-5'" style="color:#fff; cursor: pointer; z-index:10;" @click="cerrarSesion()">Cerrar sesión</u>
                </p> 
              </div>
            </b-col>  
         </b-row>
        </b-col>    
        <b-col cols="10" md="6" lg="6" xl="6" class="text-center" :style="isMobile ? 'margin-top:-7px; margin-left:20px;' : 'margin-top:-75px; margin-left:50px;'" > 
          <div data-aos="zoom-in-down" >
            <b-row class="justify-content-center"> 
               <b-col cols="10" md="4" lg="4" xl="4"> 
                  <img :src="nav == 1 ? 'elementos/bases/bases_on.png' : 'elementos/bases/base_b2.png'" class="rounded" alt="Image" :style="isMobile ? 'width:90%;' : 'width:80%; cursor:pointer;'"  @click="cambiarNav(1)">
               </b-col>
               <b-col cols="10" md="4" lg="4" xl="4" :class="isMobile ? 'mt-5' : ''">
                   <img :src="nav == 2 ? 'elementos/rankin/ranking_on.png' : 'elementos/rankin/ranking.png'" class="rounded" alt="Image" :style="isMobile ? 'width:90%;' : 'width:80%; cursor:pointer;'"  @click="cambiarNav(2)">
               </b-col>
               <b-col cols="10" md="4" lg="4" xl="4"  :class="isMobile ? 'mt-5' : ''"> 
                  <!-- <br v-if="isMobile"> -->
                  <img :src="nav == 3 ? 'elementos/aviso/avisos_on.png' : 'elementos/aviso/avisos.png'" class="rounded" alt="Image" :style="isMobile ? 'width:90%;' : 'width:80%; cursor:pointer;'"  @click="cambiarNav(3)">       
               </b-col> 
            </b-row>
          </div>
             <img  src="img/estrella.webp" class="rounded zoom-in-out-box mt-5"  alt="Image" :style="isMobile ? 'width:13%; margin-left: 45px;' : 'width:6%; margin-left: 45px;'">  
        </b-col>
        <b-col cols="11" md="11" v-if="isMobile"> 
          <b-row class="justify-content-center">   
            <b-col cols="11" md="6" v-if="!isMobile">

            </b-col>
            <b-col cols="10" md="6"  lg="4" xl="4" > 
              <div data-aos="zoom-in-down" >
                  <p :class="isMobile ? 'text-white mt-5 text-center' : 'text-white text-right'" style="font-size: 17px; "  v-if="user"> 
                    ¡HOLA! {{user.nombre}}   <br>
                    <b>   
                      <span class="text-secondary"  v-if="user.canal == 3"><b style="color:#fff;">&nbsp;&nbsp; PROPIO</b></span>
                      <span class="text-secondary"  v-if="user.canal == 2"><b style="color:#fff;">&nbsp;&nbsp; TELEMARKETING</b></span>
                      <span class="text-secondary"  v-if="user.canal == 1"><b style="color:#fff;">&nbsp;&nbsp; RETAIL</b></span> 
                      <span class="text-secondary"  v-if="user.canal == 4"><b style="color:#fff;">&nbsp;&nbsp; ESPECIALISTA</b></span> 
                    </b>
                    <br>
                    <img  src="elementos/hom.png" :class="!isMobile ? 'rounded' :'rounded'" alt="Image"  :style="!isMobile ? 'width:4.5%; cursor:pointer;  margin-top:-2px;' : 'width:9%; cursor:pointer; margin-top:-2px;'" @click="cambiarNav(0)"> 
                  &nbsp;&nbsp;<u :class="isMobile ? 'ml-5 mt-5' : 'ml-5 mt-5'" :style="nav == 7 ? 'color:#fff; cursor: pointer; z-index:10;' : 'color:#fff; cursor: pointer; z-index:10;'" @click="cambiarNav(7)">Contacto</u> 
                  &nbsp;&nbsp;<u :class="isMobile ? 'ml-5 mt-5' : 'ml-5 mt-5'" style="color:#fff; cursor: pointer; z-index:10;" @click="cerrarSesion()">Cerrar sesión</u>
                  <br v-if="!isMobile"> 
                  </p>
                <br>
               </div>
              </b-col>  
          </b-row>
           <img  src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:13%; margin-left:5px; margin-top: -450px;"> 
        </b-col>   
      </b-row>
     <div id="menoabajo"></div> 
     <template v-if="nav == 0">  
  
       <div data-aos="slide-down">
          <b-row class="justify-content-center" > 
            <b-col cols="11" md="5" lg="12" xl="12"> 

                <center :style="!isMobile ? 'margin-top: 105px;' : 'margin-top: 5px;'">
                      <template v-if="isMobile"> 
                        <img src="elementos/homes.png" :class="efecto == 0 ? 'rounded' : 'rounded btn-flotante'" alt="Image" style="width:90%;">  
                      </template>
                      <template v-else>
                        <img src="elementos/homes.png" :class="efecto == 0 ? 'rounded' : 'rounded btn-flotante'"  alt="Image" style="width:45%;">  
                      </template>
                </center>
            </b-col>
          </b-row>
      </div>
        <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:55px; margin-top:-250px;" v-if="!isMobile"> 
        <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1855px; margin-top:-650px;" v-if="!isMobile">  
       <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1225px; margin-top:-50px;" v-if="!isMobile">  
     </template>
      <template v-if="nav == 1">
        <Bases></Bases>
     </template>
     <template v-else-if="nav == 2"> 
        <Ranking></Ranking> 
     </template> 
     <template v-else-if="nav == 3">
      <br>
      <b-row class="justify-content-center"> 
         <b-col cols="12" md="5" lg="8" xl="8">  

           <b-row class="justify-content-center" >
                  <b-col cols="10" md="6" >
                      <center>
                        <!-- <img src="elementos/logo.png" class="rounded" alt="Image" :style="isMobile ? 'width:95%;' : ''"> -->
                          <br><br v-if="!isMobile">
                          <br v-if="!isMobile"> <br v-if="!isMobile">
                        <video id="video" class="video-js vjs-default-skin" width="640px" height="267px" :style="isMobile ? 'max-width:1006px;width:90%;height:auto;' :'max-width:1006px;width:100%;height:auto;'"
                                              controls preload="auto" poster='img/video.jpg'
                                              data-setup='{ "aspectRatio":"748:549" }'>
                                              <source src="img/Video_Manifiesto_Rifados.mp4" type="video/mp4" >
                          </video>
                           <br>  <br><br>
                              <img src="img/orgullomexa.png" class="rounded"  alt="Image" :style="isMobile ? 'width:95%;' : 'width:75%;'"> 
                      </center>
                  </b-col>
              </b-row>

         </b-col>
      </b-row>
          <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:55px; margin-top:-250px;" v-if="!isMobile"> 
          <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1455px; margin-top:-650px;" v-if="!isMobile">  
          <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1225px; margin-top:-50px;" v-if="!isMobile">   
      <br><br>
     </template> 
     <template v-else-if="nav == 7">
       <Contacto></Contacto>
     </template>
     <template v-else-if="nav == 8">
      <center>
      <br> 
       <h1 :style="isMobile ? 'color:#fff; font-family:Guthen Bloots Personal Use, sans-serif; font-size: 55px;' : 
        'color:#fff; font-family:Guthen Bloots Personal Use, sans-serif; font-size: 70px;'"> 
          Importante
        </h1>    
        <h4 style="color:#fff; ">Todo personal interno y externo debe seguir el flujo actual  de Capacitación. <br v-if="!isMobile">
         Todas las Capacitaciones cuentan y suman puntos <br v-if="!isMobile">
          de acuerdo con el rol y canal que participas. 
        </h4>
         <br> 
         <a href="https://conocemas.ethinksites.com/login/index.php" target="_blank" style="cursor: pointer;">
          <b-img  src="elementos/conoc.png" alt="Image"   :style="isMobile ? '  width: 50%;' : 'width: 13%; cursor:pointer;'"></b-img>
         </a>
        </center> 
     </template>
      <!-- <template v-if="nav == 0 && !isMobile">
        <br v-if="!isMobile"><br v-if="!isMobile">
           <div>
                <p class="mt-2 text-white text-center"   style="font-size:40px;"><b>FALTAN...</b></p> 
                <center>
                  <h2 class="mt-3" style="cursor:pointer; font-size:110px;   margin-top:-60px;" >
                    <p id="demo">{{reloj}}</p>
                  <p id="demo2" style="margin-top:-80px;">&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size:20px;">&nbsp;&nbsp; &nbsp; &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp;  
                      DÍAS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;   &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;&nbsp; &nbsp; 
                      HORAS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  
                      MINS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;  
                      SEGS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;    </span></p>
                  </h2> 
                   <p class="mt-2 text-white text-center"  style="font-size:40px;"><b>PARA SENTIRTE TRENDING TOPIC</b></p> 
                </center>
            </div>
      </template> -->


    <b-modal id="actualizaMRT" title=" " hide-footer hide-header no-close-on-backdrop :hideHeaderClose="true" :cancelDisabled="true" body-bg-variant="dark">
        <div class="text-center text-white" >            
            <h4 class="mt-4" style="color:#8d3fe1;" v-if="enviado == 0">Importante</h4>            
            <h4 class="mt-4" style="color:#8d3fe1;" v-else>Aviso</h4>         
            <p class="mt-4 text-white" v-if="enviado == 0 && confirma == 0">Para continuar con el ingreso <br> comparte tu AXC/MRT/MRN</p>
            <p class="mt-4 text-white" v-else-if="enviado == 1 && confirma == 0">Tu información se ha enviado exitosamente.</p>
            <b-row class="justify-content-center">
              <b-col cols="8" v-if="enviado == 0">
                <template v-if="confirma == 0">
                  <b-form-input v-model="mrt" placeholder="AXC/MRT/MRN"   type="text"  class=" text-center mt-4" />
                  <div class="text-center">
                    <p class="text-danger mt-2" v-if="errors.includes( 'mrt' )"><b>Ingresa tu AXC/MRT/MRN.</b></p>
                    <p class="text-danger mt-2" v-if="errors.includes( 'falso' )"><b>AXC/MRT/MRN Incorrecto. <br> favor de verificar.</b></p>
                  </div>
                </template>
                <template v-else>
                  <p class="mt-4 text-white">¿Es este tu AXC/MRT/MRN?.</p>
                  <b-form-input v-model="mrt" placeholder="AXC/MRT/MRN"   type="text"  class=" text-center mt-4" />
                  <b-row class="justify-content-center">
                    <b-col cols="4">
                       <v-btn  color="#8d3fe1"  class="mt-3"  dark style="text-transform:capitalize; width: 50%;" @click="bajarModal()">
                          SI
                       </v-btn>
                    </b-col>
                    <b-col cols="4">
                       <v-btn  color="#5cb615"  class="mt-3"  dark style="text-transform:capitalize; width: 50%;" @click="confirma = 0">
                          NO
                       </v-btn>
                    </b-col>
                  </b-row>

                </template>
                <v-btn  color="#8d3fe1"  class="mt-3"  dark style="text-transform:capitalize; width: 50%;" @click="enviarMRT()" v-if="confirma == 0">
                  Enviar <b-spinner v-if="loader" small></b-spinner> 
                </v-btn>
                <br>
              </b-col>
              <b-col cols="8" v-else>
                <v-btn  color="#8d3fe1"  class="mt-3"  dark style="text-transform:capitalize; width: 50%;" @click="bajarModal()">
                  OK
                </v-btn>
                <br>
              </b-col>
            </b-row>
            <br>
        </div>
    </b-modal>

      <template v-if="zoom == 1">
       <br><br><br><br>  <br><br><br><br>  <br><br><br><br>  <br><br><br><br> 
      </template>
  </div>
</div>
</template>

<script> 

import $ from "jquery";
import Cookies from "js-cookie"; 
import * as moment from 'moment'; 
import Contacto from './Contacto.vue'; 
import Bases from './Bases.vue'; 
import Ranking from './Ranking.vue'; 
export default {
  name: 'Home',
  components: { 
    Ranking,
    Contacto,
    Bases
  },
  data(){
    return{
      zoom:0,
      isMobile: this.$mobile(),
      loader:false,
      nav:0,
      countdown: moment.utc(61).format('DD:HH:mm:ss'),
      expires_in: null,
      interval: null,
      Clickinterval: false,
      reloj: "",
      mrt:"",
      errors:[],
      enviado:0,
      actualiza:0,
      confirma:0,
      drawer: false,
      group: null,
      items: [
        {
          title: 'Foo',
          value: 'foo',
        },
        {
          title: 'Bar',
          value: 'bar',
        },
        {
          title: 'Fizz',
          value: 'fizz',
        },
        {
          title: 'Buzz',
          value: 'buzz',
        },
      ],
      vertical:0,
      base_sub:"",
      rankin_sub:"",
      menu_base:0,
      menu_rankin:0,
      efecto:0
    }
  },
  computed: {
    user() {
      return this.$store.getters.getInfoUser;
    }
  },
  created(){
     this.$bus.$on("actualiza_vertical",
      () => {
        this.vertical = 1;
      });

  },
  methods:{
    apibitacora(id){
      var seccion = "";
      switch (id) {
        case 1:
          seccion = 'Bases';
        break; 
        case 2:
          seccion = 'Ranking';
        break;
        case 3:
          seccion = 'Avisos importantes';
        break;
        case 4:
          seccion = 'Likes';
        break;
        case 5:
          seccion = 'Hashtags Ocultos';
        break;
        case 6:
          seccion = 'Los + Virales';
        break;
        case 7:
          seccion = 'Contacto';
        break;
        case 8:
          seccion = 'Capacitación';
        break;
      }
     this.$api.post('auth/bitacora', {
          'correo' : this.user.email,
          'mrt' : this.user.mrt,
          'canal' : this.user.canal,
          'perfil' : "",
          'region' : 'N/A',
          'url' : id == 9 ?  '/' : '/' + seccion,
          'seccion' : id == 9 ? 'Home' : seccion,
          'accion' : id == 9 ? 'Cerro Sesión'  : 'Accedio',
          'detalle' : id == 9 ? 'Salio de convención' : 'Consulto la sección ' + seccion,
        }).then(
          response => {
             console.log(response);
          })
    },
    cambiaPerfilR1(id){
      this.menu_base = id; 
      this.base_sub = 'retail_lider6';  
      this.$bus.$emit("cambi_fo6", true)
    },
    cambiaPerfilE1(id){
      this.menu_base = id; 
      if (id == 1) {
        this.base_sub = 'especialista_distribuidor6';  
      }else if(id == 2){
        this.base_sub = 'especialista_kams6';  
      }else{
        this.base_sub = 'especialista_lider6';  
      }
      
      this.$bus.$emit("cambi_fo6", true)
    },
    cambiaPerfilP1(id){
      this.menu_base = id; 
      if (id == 1) {
        this.base_sub = 'propio_ejecutivo6';  
      }else if(id == 2){
        this.base_sub = 'propio_gerente6';  
      }else{
        this.base_sub = 'propio_lider6';  
      }
      
      this.$bus.$emit("cambi_fo6", true)
    },
    cambiaRankinR1(id){
      this.menu_rankin = id;
      this.rankin_sub = 'retail_lider1';
      this.$bus.$emit("cambi_fo61", true)
    },
    cambiaRankinE1(id){
      this.menu_rankin = id;
      if (id == 1) {
        this.rankin_sub = 'especialista_distribuidor1';  
      }else if(id == 2){
        this.rankin_sub = 'especialista_kams1';  
      }else{
        this.rankin_sub = 'especialista_lider1';  
      }
      
      this.$bus.$emit("cambi_fo61", true)
    },
    cambiaRankinP1(id){
      this.menu_rankin = id;
      if (id == 1) {
        this.rankin_sub = 'propio_ejecutivo1';  
      }else if(id == 2){
        this.rankin_sub = 'propio_gerente1';  
      }else{
        this.rankin_sub = 'propio_lider1';  
      }
      
      this.$bus.$emit("cambi_fo61", true)
    },
    // cambiaRankin(id){
    //   this.menu_rankin = id;
    //   this.rankin_sub = '';
    //      this.$bus.$emit("cambi_fo61", true)
    // },
    cambiaBase(id){
      this.base_sub = id;
      if (this.isMobile)
      { 
          window.scroll(0, 800);
      } 

    },
    cambiaBase2(id){
      this.rankin_sub = id;
      if (this.isMobile)
      { 
          window.scroll(0, 800);
      } 

    },
    cambiarNav(id){
      console.log(id);
      if (this.isMobile && this.nav == 0)
          {
             this.$bus.$emit("cambi_fo22", true)
             window.scroll(0, 200);
          } 

        this.nav = id; 

          if (this.isMobile && this.nav == 0)
          {
             location.reload();
          } 

        this.apibitacora(this.nav);


        if(this.isMobile && this.nav == 2){
            this.$bus.$emit("cambi_fo21", true)
        }

        if(this.isMobile && this.nav == 3){
            this.$bus.$emit("cambi_fo21", true)
        }




        if (this.isMobile && this.nav == 1) {
           this.$bus.$emit("cambi_fo2")
        } 

        this.menu_base = 0;
        this.menu_rankin = 0;
        this.base_sub = ""; 

        // window.AOS.refresh();
        // else if (!this.isMobile && this.nav != 0)
        // {
        //    this.$bus.$emit("fondosolo", true)
        // }else if(!this.isMobile && this.nav == 0){
        //    this.$bus.$emit("fondosolo2", true)
        // }

        if (!this.isMobile && this.nav == 0)
        {
             setTimeout(() => {
                this.efecto = 1; 
                    setTimeout(() => {
                      this.efecto = 0; 
                    }, 1400) 
              }, 700) 

        }
    },
    aceptaBienvenida(){
      this.loader = true;
      var url= 'auth/bienvenida?id='+ this.user.id;
        this.$api.get(url).then(
            ({data}) => {
                console.log(data);
                this.loader = false;
                this.$router.push("/");       
            }
        );
    },
    cerrarSesion(){
       this.apibitacora(9);

      setTimeout(() => {
          this.$store.commit(
              "setLoginStatus",
              false
          );
          this.$store.commit(
              "setInfoUser",
              null
          );    
          Cookies.remove("session_id");
          location.reload();
        }, 700)
    },
    setInterval: function() {
        this.interval = setInterval(() => {
            var countDownDate = new Date("Feb 09, 2024 10:00:00").getTime();

                    // Get today's date and time
              var now = new Date().getTime();
                
              // Find the distance between now and the count down date
              var distance = countDownDate - now;

            
                
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var ceroD = days < 10 ? '0' + days : days;
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var ceroH = hours < 10 ? '0' + hours : hours;
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var ceroM = minutes < 10 ? '0' + minutes : minutes;
            var seconds =  Math.floor((distance % (1000 * 60)) / 1000);
            var ceroS = seconds < 10 ? '0' + seconds : seconds ;
            // Output the result in an element with id="demo"
            this.reloj =  ceroD  + " . " +   ceroH + " . " +  ceroM + " . " +   ceroS;         

         }, 1000);
    },
    enviarMRT(){
      this.errors = [];
      if (!this.mrt) {
        this.errors.push('mrt');   
      }
      if(this.mrt.includes("AXC") == false && this.mrt.includes("MRT") == false && this.mrt.includes("MRN") == false){
        this.errors.push('falso');   
      }else{
        this.loader = true;
        var url= 'home/actualiza?id='+ this.user.id + '&mrt='+ this.mrt;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.loader = false;
                    this.enviado = 1;                   
                }
            );
      }
    },
    bajarModal(){
      this.enviado = 0;
      this.$bvModal.hide('actualizaMRT');
    },
    traeAct(){
      var url= 'home/trae?id='+ this.user.id;
        this.$api.get(url).then(
            ({data}) => {
                console.log(data);
                if (this.user.perfil == 'Ejecutivo')
                  {
                    if (!data.actualiza)
                    {
                      this.confirma = 0;
                    }else{
                      this.confirma = 1;
                      this.mrt = data.actualiza;
                    }

                    this.$bvModal.show('actualizaMRT');
                  }     
            }
        );
    }
  },
  mounted(){
    this.setInterval();
     var height  = $(window).height();
     console.log(height);
     if (height < 950 && !this.isMobile)
     {
       document.body.style.zoom='75%'; 
       this.zoom = 1;
     } 

     if (window.orientation == '90' && this.isMobile || window.orientation == '-90'  && this.isMobile )
     {
       this.vertical = 1;
     } 

    if (this.isMobile && this.nav == 0) {
        this.$bus.$emit("cambi_fo22")
    }

     this.$bus.$emit("fondo_capa", "fondoSolo")


     window.AOS.init({
      // offset: 20,
      duration: 500,
      easing: 'ease-in-sine',
      delay: 300,
      anchorPlacement:'top-bottom', 
    }); 

    setTimeout(() => {
      this.efecto = 1; 
          setTimeout(() => {
            this.efecto = 0; 
          }, 1300) 
    }, 800) 

  }
} 
</script>
<style >


#demo{
   -webkit-text-stroke: 2px #fff;
  color: #fff; 
}
#demo2{
   -webkit-text-stroke: 0.1px #fff;
  color: #fff; 
}

@media only screen and (min-width: 1000px) 
{
        #menus
        {
            height: 30%;
            font-size: 12px;
            width: 100%;
            margin: 90px;
             margin-left: -10px;
        }

                     #faltan
        {
          margin-left: 230px;
        }
        #fotoN{
          margin-top: 32px;
        }

        #fotoS{
           width: 90%;
           margin-top: -10px;
        } 
}
@media only screen and (min-width: 1300px) 
{
        #menus
        {
            height: 30%;
            font-size: 12px;
            width: 100%;
            margin: 80px;
              margin-left: -10px;
        }

             #faltan
        {
          margin-left: 260px;
        }

        #fotoN{
          margin-top: 25px;
        } 

        #fotoS{
           width: 70%;
           margin-top: -10px;
        } 

}
@media only screen and (min-width: 1400px)
{
        #menus
        {
            height: 30%;
            font-size: 15px;
            width: 100%;
            margin: 80px;
              margin-left: -10px;
        }

        #faltan
        {
          margin-left: 340px;
        }

        #fotoN{
          margin-top: 18px;
        }

        #fotoS{
           width: 70%;
           margin-top: -10px;
        }
}
@media only screen and (min-width: 1600px)
{
        #menus
        {
            height: 30%;
            font-size: 15px;
            width: 60%;
            margin: 80px;
              margin-left: -10px;
        }

         #faltan
        {
          margin-left: 425px;
        }

        #fotoN{
          margin-top: -10px;
        }

        #fotoS{
           width: 60%;
           margin-top: -10px;
        }
}
@media only screen and  (min-width: 1800px)
{
        #menus
        {
            height: 35%;
            font-size: 15px;
            width: 100%;
            /* margin: 80px; */
            margin-left: -10px;
        }

        #faltan
        {
          margin-left: 600px;
        }

        #fotoN{
          margin-top: -10px;
        }

        #fotoS{ 
          width: 50%;
          margin-top: -10px;
        }
} 
 
.btn-flotante {   
    transition: all 300ms ease 0ms;
    /* box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1); */
    z-index: 99;
    animation: myAnim 10s ease-in-out 0s infinite alternate-reverse forwards;
  }
  .btn-flotante:hover {
    background-color: transparent; /* Color de fondo al pasar el cursor */
    /* box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.3); */
    transform: translateY(-7px);
  }

  @keyframes myAnim {
    0% {
      animation-timing-function: ease-in;
      opacity: 1;
      transform: translateY(-45px);
    }

    24% {
      opacity: 1;
        animation-timing-function: ease-in;
      transform: translateY(-84px);
    }

    40% {
      animation-timing-function: ease-in;
      transform: translateY(-84px);
    }

    65% {
      animation-timing-function: ease-in;
      transform: translateY(-94px);
    }

    82% {
      animation-timing-function: ease-in;
      transform: translateY(-94px);
    }

    93% {
      animation-timing-function: ease-in;
      transform: translateY(-104px);
    }

    25%,
    55%,
    75%,
    87% {
      animation-timing-function: ease-out;
      transform: translateY(0px);
    }

    100% {
      animation-timing-function: ease-out;
      opacity: 1;
      transform: translateY(0px);
    }
  }

 .zoom-in-out-box { 
  animation: zoom-in-zoom-out 3s ease infinite; 
}

@keyframes zoom-in-zoom-out {
  0% {
    scale: 100%
  }
  50% {
    scale: 150%;
  }
  100% {
    scale: 100%;
  }
}
</style>